import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-rech-rep-leg',
  templateUrl: './modal-rech-rep-leg.component.html',
  styleUrls: ['./modal-rech-rep-leg.component.css']
})
export class ModalRechRepLegComponent implements OnInit {

  //@Output() closeModalR = new EventEmitter<void>();
  form: FormGroup;
  params: any;
  private lovs:string = environment.lovs;
  private rechazosol:string = environment.rechazosol;

  motivosLov: any[] = [];

  constructor(private http: HttpClient, private fb: FormBuilder, private router: Router, private modalService: NgbModal, public parametroAccionService : ParametroAccionService, private toastr: ToastrService) {
    this.form = this.fb.group({
      nroSol: [],
      rutEmpr: [],
      razonSocial: [],
      rutRep: [],
      nombreRep: [],
      correoRep: [],
      creationDate: [],
      motivo: []
    });

    this.params = this.parametroAccionService.obtenerDatos();
    if (this.params) {
      this.form.controls['nroSol'].setValue(this.params.SEQ_NRO_SOLICITUD_CDG);
      this.form.controls['rutEmpr'].setValue(this.params.RUT_EMPRESA+"-"+this.params.DV_EMPRESA);
      this.form.controls['razonSocial'].setValue(this.params.RAZON_SOCIAL);
      this.form.controls['rutRep'].setValue(this.params.RUT_REPRESENTANTE+"-"+this.params.DV_REPRESENTANTE);
      this.form.controls['nombreRep'].setValue(this.params.NOMBRE_REPRESENTANTE_LEGAL);
      this.form.controls['correoRep'].setValue(this.params.CORREO_ELECTRONICO);
      this.form.controls['creationDate'].setValue(this.params.CREATION_DATE);
      this.form.get('nroSol').disable();
      this.form.get('rutEmpr').disable();
      this.form.get('razonSocial').disable();
      this.form.get('rutRep').disable();
      this.form.get('nombreRep').disable();
      this.form.get('correoRep').disable();
      this.form.get('creationDate').disable();
      
    }  
    this.obtenerMotivos();  
  }


  ngOnInit(): void {
  }

  onSubmit() {
    this.http.post<any>(this.rechazosol, { 
      rut_empresa: this.params.RUT_EMPRESA,
      rut_representante_legal: this.params.RUT_REPRESENTANTE,
      nro_solicitud: this.params.SEQ_NRO_SOLICITUD_CDG,
      codigo_rechazo: this.form.get('motivo').value
    }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const status = response.status;
      const data = response.body;
      if (status===200) { 
        if (data.totalRecords>0) {
          this.toastr.success("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" rechazada correctamente.");
          this.modalService.dismissAll();
        }else{
          this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
          this.modalService.dismissAll();
        }
      }else{
        this.toastr.error("Solicitud "+this.params.SEQ_NRO_SOLICITUD_CDG+" con error: "+data.Resultado.error);
        this.modalService.dismissAll();
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      this.modalService.dismissAll();
    });
  }
  
  onCloseModalR() {
    this.modalService.dismissAll();
  }

  obtenerMotivos() {
    // Realiza la llamada al servicio HTTP para obtener motivos
    this.http.post<any>(this.lovs, { 
      codigo_lista: 5,
      codigo_region: "",
    }).subscribe((data: any) => {
      //console.log(data);
      //console.log(data.Resultado);
      this.motivosLov = data.Resultados;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
  }

}
